import styled from 'styled-components';
import { Card } from '../Card';

export const MultiSelectionMenuContainer = styled(Card)<{ offset: number }>`
  position: fixed;
  bottom: ${({ theme }) => theme.mosaiq.spacing(4)}px;
  z-index: ${({ theme }) => theme.mosaiq.zIndexes.navsidebar - 1};
  height: 45px;
  border-radius: ${({ theme }) => theme.mosaiq.spacing(1)}px;
  background-color: ${({ theme }) => theme.mosaiq.colors.black};
  color: ${({ theme }) => theme.mosaiq.colors.white}px;
  left: ${({ offset }) => `calc(50% + ${offset}px)`};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.mosaiq.spacing(1)}px;
  transform: ${({ offset }) => `translateX(calc(-50% - ${offset / 2}px))`};
`;
